import { render, staticRenderFns } from "./restartB.vue?vue&type=template&id=1b618ec1&scoped=true&"
import script from "./restartB.vue?vue&type=script&lang=js&"
export * from "./restartB.vue?vue&type=script&lang=js&"
import style0 from "./restartB.vue?vue&type=style&index=0&id=1b618ec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b618ec1",
  null
  
)

export default component.exports